import http from "../../http-common";

const getAll = (initDate, endDate, token, username, company, filters) => {
  return http.post(
    `/api/v1/teams/cdr/noelk?limit=99999&initDate=${initDate}&endDate=${endDate}&token=${token}&username=${username}&company=${company}`,
    { filters: filters }
  );
};

const getIncoming = () => {
  return http.get(
    `/pbx/loadCdr?company=20152&filters=%7B%22direction%22:%7B%22incoming%22:true,%22outgoing%22:false,%22internal%22:false%7D,%22callStatus%22:%7B%22answered%22:false,%22notAnswered%22:false%7D,%22number%22:%22%22,%22date%22:%7B%22initDate%22:%22%22,%22endDate%22:%22%22%7D,%22company%22:%7B%7D%7D&limit=100&month=202204&order=-calldate&page=1`
  );
};

const getOutgoing = () => {
  return http.get(
    `/pbx/loadCdr?company=20152&filters=%7B%22direction%22:%7B%22incoming%22:false,%22outgoing%22:true,%22internal%22:false%7D,%22callStatus%22:%7B%22answered%22:false,%22notAnswered%22:false%7D,%22number%22:%22%22,%22date%22:%7B%22initDate%22:%22%22,%22endDate%22:%22%22%7D,%22company%22:%7B%7D%7D&limit=100&month=202204&order=-calldate&page=1`
  );
};

const update = (id, data) => {
  return http.put(`/tutorials/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/tutorials/${id}`);
};

const removeAll = () => {
  return http.delete(`/tutorials`);
};

const findByTitle = (title) => {
  return http.get(`/tutorials?title=${title}`);
};

const getDistributionByQueue = (initDate, endDate) => {
  return http.get(
    `/routes/teams/stats/attendedByDate?limit=99999&initDate=${initDate}&endDate=${endDate}`
  );
};

const CdrService = {
  getAll,
  getIncoming,
  getOutgoing,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default CdrService;
